<template>
  <div class="list" >
    <header  class="list__header" color="#16336E" style="border-top-right-radius: 0px;">{{list_name}}</header>
    <ul style="padding-left:10px;">
      <v-list-item-subtitle v-if="proposals.length !== 0">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          single-line
          x-small
          :label="$t('BsList.search_name')"
          color="#15336d"
        ></v-text-field>
      </v-list-item-subtitle>
      <v-spacer style="height:10px;"></v-spacer>
      <div  v-for="(item, index) in (saveProposal.length > 0 ? saveProposal : proposals)" :key="index">
        <li class="d-flex justify-space-between align-center" :class="item.row_class">
        <!-- <li class="d-flex justify-space-between align-center" :class="row_classes(item)" :style="{background: item.color}"> -->
          <div @click.stop="open_proposal_card(item.id)" style="width: 100%;" >
            <v-row class="ma-0">
              <strong> №{{item.id}} {{item.name ? item.name: $t('BsList.application_not_specified')}} </strong>
            </v-row>
            <v-row class="ma-0">
              <v-chip
                class=""
                color="#15336d"
                label
                dark
                x-small>
                <v-icon left x-small>mdi-account-circle-outline</v-icon>
                {{item.author}}
              </v-chip>
            </v-row>
            <!-- <br>   -->
             <v-row class="ma-0">
              <v-col class="pa-0">
                <v-icon left x-small>mdi-calendar</v-icon><i style="font-size:10px">от {{g.toDate(item.date_income)}}</i> <br>
              </v-col>
              <v-col style="text-align: end;" class="pa-0">

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      rounded
                      :color="calc_color(item)"
                      x-small
                    >
                      {{ item.available_time }}
                    </v-btn>
                  </template>
                  <span>осталось невыделенных часов</span>
                </v-tooltip>
              </v-col>
             </v-row>
          </div>
        </li>
        <v-spacer></v-spacer>
    </div>
    </ul>
    <footer style="padding-top:15px; padding-bottom:10px;"> 
      <v-progress-linear
          v-if="proposals.length === 0 && !noDataProposals"
          indeterminate
          color="#16336E"
        ></v-progress-linear>
      <template v-else>
        <template v-if="!disabledLoadYet">          
          <v-badge
            :value="hover"
            color="#16336E"
            :content="$t('BsList.load_more_applications')"
            bottom
            transition="slide-x-transition"
          >
            <v-hover v-model="hover">
              <v-btn fab x-small dark color="#16336E" style="margin-right:5px;" @click="showMoreProposals()">
                <v-icon> mdi-arrow-right-bold</v-icon>  
              </v-btn>
            </v-hover>
          </v-badge>
        </template>
        <v-chip
          v-if="noDataProposals"
          style="width:100%"
          color="blue-grey lighten-2"
          outlined
        >
          <v-icon left>mdi-emoticon-sad</v-icon>
          {{$t('BsList.no_applications')}}
        </v-chip>
      </template>
    </footer>


  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'

export default {
    props: {
      list_name: [String, Number],
    },
    components: {
    },
    name: 'CurrentProposalColList',
    data: () => ({
        search: '',
        saveProposal: [],
        proposals: [],
        allProposals: [],
        noDataProposals: false,
        page: 1,
        disabledLoadYet: true,        // отображение кнопки загрузить больше заявок
        hover: false,
        pageCount : 1,
        call_id: null,
    }),

    computed: {
      ...mapGetters([
        'GETTERS_CURRENT_STATION',
        'GETTERS_NEED_RELOAD_CLOSE_PROPOSAL',
        'GETTERS_NEED_RELOAD_PROPOSAL_LIST',
        'GETTERS_NEED_RELOAD_CALENDAR',
      ])
    },

    methods:{
      ...mapActions([
        'PROPOSAL_VARIABLE_LIST',
      ]),

      ...mapMutations([
        'SHOW_PROPOSAL_CARD',
      ]),

      open_proposal_card(id) {
        this.call_id = new Date()
        this.SHOW_PROPOSAL_CARD({
          'proposal_id' : id,
          'call_id': this.call_id
        })
      },

      async loadListProposals(status_id) {                
        var args = {
          type: 'current_bs_proposals',
          filters: {
              station_id : this.GETTERS_CURRENT_STATION
          },
        }

        await this.PROPOSAL_VARIABLE_LIST(args)
        .then(proposals => {
          var now = (new Date()).toISOString()
          this.allProposals = proposals;
          
          this.allProposals.forEach((item, i) => {
            if(item.last_status_id == 4){
              item.row_class = 'orange_bg'
            }
            else if((!item.extension_to && now > item.session_end) || (item.extension_to && now > item.extension_to) ){
              item.row_class = 'red_bg'
            }
            else{
              item.row_class = ''
            }

            if(item.last_status_id == 4){
              item.provided_experiment_duration = item.council_provided_experiment_duration
            }
            else if(item.last_status_id >  4 && !item.provided_experiment_duration)
              item.provided_experiment_duration = '720'

            if(item.sheduled_sec && item.sheduled_sec.length > 0){
              var sheduled = parseFloat(item.sheduled_sec)/3600
              var provided = parseFloat(item.provided_experiment_duration)

              item.available_time = ( (provided - sheduled).toString() + ' из ' + item.provided_experiment_duration) + ' (ч)'
            }
            else{
              item.available_time = (item.provided_experiment_duration + ' из ' + item.provided_experiment_duration) + ' (ч)'
            }
          })

          if (proposals.length !== 0) {
            this.noDataProposals = false
            this.pageCount = Math.ceil((this.allProposals.length)/6);
            if (this.pageCount > 1){
              this.disabledLoadYet = false;
              this.proposals = this.allProposals.slice(0,6);
            }
            else{
              this.proposals = this.allProposals
              this.disabledLoadYet = true;
            }
          }
          else{
            this.proposals = []
            this.noDataProposals = true
          }
        })
      },


      calc_color(item){
        return 'primary'
      },

      showMoreProposals(){
        this.page++;
        this.proposals = this.allProposals.slice(0,(this.page*6));
        if(this.pageCount == this.page){
          this.disabledLoadYet = true; 
        }
      },
    },

    async beforeMount() {
        this.loadListProposals()
    },

    watch: {
      GETTERS_CURRENT_STATION(val){
        if(val){
          this.loadListProposals()
        }
      },
      
      GETTERS_NEED_RELOAD_CLOSE_PROPOSAL(val){
        if(val && val == this.call_id){
          this.loadListProposals()
        }
      },

      GETTERS_NEED_RELOAD_PROPOSAL_LIST(val){
        if(val){
          this.loadListProposals()
        }
      },

      GETTERS_NEED_RELOAD_CALENDAR(val){
        if(val){
          this.loadListProposals()
        }
      },

      search(val) {
        if (val.length === 0) {
          this.saveProposal = []
        }
        else{
          this.saveProposal = this.allProposals.filter(item => {
            if (item.name !== null) {
              return item.name.toLowerCase().includes(val.toLowerCase())
            }
          })
        }
      },
    }
};

</script>

<style scoped>
.btn-load-more{
    color: rgb(22, 51, 110);
    border-radius: 0px;
    box-shadow: none;
    width: 100%;
    z-index: 1;
    background-color:#e2e4e6;
}
li{ 
  cursor: pointer;
}
li *{ 
  line-height: 15px !important;
}
li:hover{
  background-color: #eeeeee;

}
.v-list-item{
  padding: 0px 0px;
}
.list__header {
  line-height: 1.2;
  padding-top: 15px;
}
.list{
  width: 400px !important;
}
</style>
